// GitOps Pull Requests - PR Pipeline Data

export const pullRequests = [
  {
    id: 'PR-2026-0142',
    changeSpecId: 'CS-2026-0087',
    title: 'Scale Redis cluster redis-cache-prod-3',
    description: 'Increase Redis cluster capacity to handle traffic spike',
    status: 'open',
    branch: 'change/cs-2026-0087-redis-scale',
    targetBranch: 'main',
    author: 'vedaya-bot',
    createdAt: '2026-01-11T10:35:00Z',
    updatedAt: '2026-01-11T10:40:00Z',
    labels: ['environment:prod', 'risk:medium', 'auto-generated'],
    checks: {
      terraformPlan: { status: 'passed', duration: '45s', output: 'Plan: 1 to change, 0 to add, 0 to destroy' },
      policySimulation: { status: 'passed', duration: '12s', output: 'All policies passed (8/8)' },
      securityScan: { status: 'passed', duration: '23s', output: 'No vulnerabilities detected' },
      costEstimate: { status: 'passed', duration: '8s', output: 'Estimated cost increase: $180/month' },
      unitTests: { status: 'passed', duration: '2m 15s', output: 'All tests passed (24/24)' },
      integrationTests: { status: 'running', duration: null, output: 'Running...' }
    },
    approvals: {
      required: ['Platform Team Lead', 'Security Team'],
      received: [],
      status: 'pending'
    },
    diffs: {
      terraform: `# redis-cache-prod-3.tf

resource "aws_elasticache_replication_group" "redis_cache_prod_3" {
-  node_type            = "cache.r6g.large"
+  node_type            = "cache.r6g.xlarge"
-  num_cache_clusters   = 2
+  num_cache_clusters   = 4
   engine_version       = "7.0"
   parameter_group_name = "default.redis7"
   
   automatic_failover_enabled = true
   multi_az_enabled          = true
}`,
      kubernetes: null,
      policy: null,
      workflow: null
    },
    artifacts: {
      planOutput: 'terraform-plan-cs2026-0087.json',
      policyReport: 'policy-simulation-cs2026-0087.json',
      costReport: 'cost-estimate-cs2026-0087.json'
    },
    pipeline: null,
    comments: [
      { author: 'vedaya-bot', time: '2026-01-11T10:35:00Z', text: 'Change Spec CS-2026-0087 compiled successfully. PR created for review.' },
      { author: 'vedaya-bot', time: '2026-01-11T10:40:00Z', text: 'All initial checks passed. Awaiting required approvals.' }
    ]
  },
  {
    id: 'PR-2026-0141',
    changeSpecId: 'CS-2026-0086',
    title: 'Offboard user alex.rodriguez@company.com',
    description: 'Revoke access and transfer ownership for departing employee',
    status: 'merged',
    branch: 'change/cs-2026-0086-offboard-alex',
    targetBranch: 'main',
    author: 'vedaya-bot',
    createdAt: '2026-01-10T14:05:00Z',
    updatedAt: '2026-01-10T14:48:00Z',
    mergedAt: '2026-01-10T14:45:00Z',
    mergedBy: 'Jordan Lee',
    labels: ['environment:prod', 'risk:high', 'identity', 'auto-generated'],
    checks: {
      terraformPlan: { status: 'passed', duration: '32s', output: 'Plan: 0 to change, 0 to add, 0 to destroy' },
      configValidation: { status: 'passed', duration: '18s', output: 'All configurations valid' },
      policySimulation: { status: 'passed', duration: '15s', output: 'All policies passed (12/12)' },
      workflowValidation: { status: 'passed', duration: '8s', output: 'Workflow template validated' },
      securityScan: { status: 'passed', duration: '20s', output: 'No vulnerabilities detected' },
      unitTests: { status: 'passed', duration: '1m 45s', output: 'All tests passed (18/18)' },
      integrationTests: { status: 'passed', duration: '3m 20s', output: 'All tests passed (8/8)' }
    },
    approvals: {
      required: ['HR Manager', 'Security Team'],
      received: [
        { approver: 'Lisa Park (HR)', role: 'HR Manager', time: '2026-01-10T14:35:00Z' },
        { approver: 'Jordan Lee', role: 'Security Team', time: '2026-01-10T14:38:00Z' }
      ],
      status: 'approved'
    },
    diffs: {
      terraform: null,
      kubernetes: null,
      policy: null,
      workflow: `# offboard-alex-rodriguez.workflow.yaml

apiVersion: vedaya.ai/v1
kind: Workflow
metadata:
  name: offboard-alex-rodriguez
  namespace: identity
spec:
  template: workflow-user-offboarding
  version: "2.0.0"
  parameters:
    user_email: "alex.rodriguez@company.com"
    transfer_owner: "lisa.park@company.com"
    retention_days: 30
    notify_manager: true
  steps:
    - name: suspend-okta
      module: config-okta-user
      action: update
      params:
        status: SUSPENDED
    - name: remove-github
      module: config-github-team  
      action: update
      params:
        members: ["remove:alex-rodriguez"]
    - name: execute-offboarding
      module: workflow-user-offboarding
      action: execute`
    },
    artifacts: {
      planOutput: 'workflow-plan-cs2026-0086.json',
      policyReport: 'policy-simulation-cs2026-0086.json',
      auditLog: 'audit-cs2026-0086.json'
    },
    pipeline: {
      status: 'completed',
      stages: [
        { name: 'Plan', status: 'completed', startTime: '2026-01-10T14:45:30Z', endTime: '2026-01-10T14:46:00Z', output: 'Plan generated successfully' },
        { name: 'Approve', status: 'completed', startTime: '2026-01-10T14:46:00Z', endTime: '2026-01-10T14:46:05Z', output: 'Auto-approved (all required approvals received)' },
        { name: 'Apply', status: 'completed', startTime: '2026-01-10T14:46:05Z', endTime: '2026-01-10T14:47:00Z', output: 'All changes applied successfully' },
        { name: 'Smoke Tests', status: 'completed', startTime: '2026-01-10T14:47:00Z', endTime: '2026-01-10T14:47:30Z', output: 'All smoke tests passed (5/5)' },
        { name: 'Verify', status: 'completed', startTime: '2026-01-10T14:47:30Z', endTime: '2026-01-10T14:48:00Z', output: 'All verifications passed' },
        { name: 'Record', status: 'completed', startTime: '2026-01-10T14:48:00Z', endTime: '2026-01-10T14:48:05Z', output: 'Evidence bundle EB-2026-0142 created' }
      ]
    },
    comments: [
      { author: 'vedaya-bot', time: '2026-01-10T14:05:00Z', text: 'Change Spec CS-2026-0086 compiled successfully. PR created for review.' },
      { author: 'Lisa Park', time: '2026-01-10T14:35:00Z', text: 'Approved - HR verification complete.' },
      { author: 'Jordan Lee', time: '2026-01-10T14:38:00Z', text: 'Security approval granted. Merge when ready.' },
      { author: 'vedaya-bot', time: '2026-01-10T14:48:00Z', text: 'Pipeline completed successfully. Evidence bundle generated.' }
    ]
  },
  {
    id: 'PR-2026-0140',
    changeSpecId: 'CS-2026-0085',
    title: 'Create analytics-staging-db PostgreSQL instance',
    description: 'New staging database for analytics team workload',
    status: 'merged',
    branch: 'change/cs-2026-0085-analytics-db',
    targetBranch: 'main',
    author: 'Sarah Chen',
    createdAt: '2026-01-09T09:05:00Z',
    updatedAt: '2026-01-09T09:45:00Z',
    mergedAt: '2026-01-09T09:42:00Z',
    mergedBy: 'Sarah Chen',
    labels: ['environment:staging', 'risk:low', 'database', 'terraform'],
    checks: {
      terraformPlan: { status: 'passed', duration: '52s', output: 'Plan: 2 to add, 0 to change, 0 to destroy' },
      policySimulation: { status: 'passed', duration: '14s', output: 'All policies passed (10/10)' },
      securityScan: { status: 'passed', duration: '28s', output: 'No vulnerabilities detected' },
      costEstimate: { status: 'passed', duration: '10s', output: 'Estimated cost: $450/month' },
      unitTests: { status: 'passed', duration: '1m 30s', output: 'All tests passed (16/16)' },
      integrationTests: { status: 'passed', duration: '2m 45s', output: 'All tests passed (6/6)' }
    },
    approvals: {
      required: ['Data Team Lead'],
      received: [
        { approver: 'Pat Thompson', role: 'Data Team Lead', time: '2026-01-09T09:30:00Z' }
      ],
      status: 'approved'
    },
    diffs: {
      terraform: `# analytics-staging-db.tf

+ resource "aws_db_instance" "analytics_staging" {
+   identifier           = "analytics-staging-db"
+   engine              = "postgres"
+   engine_version      = "16"
+   instance_class      = "db.r6g.large"
+   allocated_storage   = 100
+   
+   multi_az            = false
+   storage_encrypted   = true
+   
+   vpc_security_group_ids = [aws_security_group.analytics_db.id]
+   db_subnet_group_name   = aws_db_subnet_group.analytics.name
+   
+   tags = {
+     Environment = "staging"
+     Team        = "data"
+     ManagedBy   = "vedaya"
+   }
+ }

+ resource "aws_security_group" "analytics_db" {
+   name        = "analytics-staging-db-sg"
+   description = "Security group for analytics staging database"
+   vpc_id      = data.aws_vpc.main.id
+   
+   ingress {
+     from_port   = 5432
+     to_port     = 5432
+     protocol    = "tcp"
+     cidr_blocks = ["10.0.0.0/8"]
+   }
+ }`,
      kubernetes: null,
      policy: `# analytics-staging-db-policy.rego

+ package vedaya.policies.analytics_staging_db
+ 
+ default allow = false
+ 
+ allow {
+   input.resource.encryption_enabled == true
+   input.resource.environment == "staging"
+ }`,
      workflow: null
    },
    artifacts: {
      planOutput: 'terraform-plan-cs2026-0085.json',
      policyReport: 'policy-simulation-cs2026-0085.json',
      costReport: 'cost-estimate-cs2026-0085.json'
    },
    pipeline: {
      status: 'completed',
      stages: [
        { name: 'Plan', status: 'completed', startTime: '2026-01-09T09:42:00Z', endTime: '2026-01-09T09:42:45Z', output: 'Plan generated successfully' },
        { name: 'Approve', status: 'completed', startTime: '2026-01-09T09:42:45Z', endTime: '2026-01-09T09:42:50Z', output: 'Auto-approved (staging environment)' },
        { name: 'Apply', status: 'completed', startTime: '2026-01-09T09:42:50Z', endTime: '2026-01-09T09:44:30Z', output: 'Terraform apply completed' },
        { name: 'Smoke Tests', status: 'completed', startTime: '2026-01-09T09:44:30Z', endTime: '2026-01-09T09:45:00Z', output: 'Database connectivity verified' },
        { name: 'Record', status: 'completed', startTime: '2026-01-09T09:45:00Z', endTime: '2026-01-09T09:45:05Z', output: 'Change recorded' }
      ]
    },
    comments: []
  },
  {
    id: 'PR-2026-0139',
    changeSpecId: 'CS-2026-0084',
    title: 'Emergency quarantine device LT-1042',
    description: 'Isolate device due to missing EDR agent - security policy violation',
    status: 'merged',
    branch: 'change/cs-2026-0084-quarantine-lt1042',
    targetBranch: 'main',
    author: 'vedaya-bot',
    createdAt: '2026-01-07T16:42:00Z',
    updatedAt: '2026-01-07T16:50:00Z',
    mergedAt: '2026-01-07T16:48:00Z',
    mergedBy: 'vedaya-bot (auto)',
    labels: ['environment:prod', 'risk:critical', 'security', 'emergency', 'auto-approved'],
    checks: {
      workflowValidation: { status: 'passed', duration: '5s', output: 'Emergency workflow validated' },
      policySimulation: { status: 'passed', duration: '8s', output: 'Emergency override - policy checks passed' },
      securityScan: { status: 'passed', duration: '10s', output: 'Quarantine action approved' }
    },
    approvals: {
      required: [],
      received: [
        { approver: 'vedaya-bot', role: 'Emergency Auto-Approve', time: '2026-01-07T16:45:00Z', note: 'Pre-approved emergency action for critical security violation' }
      ],
      status: 'auto-approved'
    },
    diffs: {
      terraform: null,
      kubernetes: null,
      policy: null,
      workflow: `# quarantine-lt1042.workflow.yaml

apiVersion: vedaya.ai/v1
kind: Workflow
metadata:
  name: quarantine-lt1042
  namespace: security
  annotations:
    vedaya.ai/emergency: "true"
    vedaya.ai/auto-approved: "true"
spec:
  template: workflow-incident-quarantine
  version: "1.1.0"
  parameters:
    device_id: "LT-1042"
    reason: "EDR agent not detected - policy violation"
    network_isolate: true
    revoke_tokens: true`
    },
    artifacts: {
      policyReport: 'emergency-policy-cs2026-0084.json',
      auditLog: 'emergency-audit-cs2026-0084.json'
    },
    pipeline: {
      status: 'completed',
      stages: [
        { name: 'Plan', status: 'completed', startTime: '2026-01-07T16:45:00Z', endTime: '2026-01-07T16:45:10Z', output: 'Emergency plan generated' },
        { name: 'Auto-Approve', status: 'completed', startTime: '2026-01-07T16:45:10Z', endTime: '2026-01-07T16:45:12Z', output: 'Pre-approved emergency action' },
        { name: 'Apply', status: 'completed', startTime: '2026-01-07T16:45:12Z', endTime: '2026-01-07T16:48:00Z', output: 'Device quarantined successfully' },
        { name: 'Verify', status: 'completed', startTime: '2026-01-07T16:48:00Z', endTime: '2026-01-07T16:49:00Z', output: 'Network isolation verified' },
        { name: 'Record', status: 'completed', startTime: '2026-01-07T16:49:00Z', endTime: '2026-01-07T16:50:00Z', output: 'Evidence bundle EB-2026-0134 created' }
      ]
    },
    comments: [
      { author: 'vedaya-bot', time: '2026-01-07T16:42:00Z', text: 'EMERGENCY: Device LT-1042 flagged for quarantine due to missing EDR.' },
      { author: 'vedaya-bot', time: '2026-01-07T16:45:00Z', text: 'Auto-approved: Pre-approved emergency action for critical security violation.' },
      { author: 'vedaya-bot', time: '2026-01-07T16:50:00Z', text: 'Quarantine completed. Device owner Emily Zhang notified via Slack.' }
    ]
  }
];

export const pipelineStages = [
  { id: 'plan', name: 'Plan', description: 'Generate execution plan from Change Spec' },
  { id: 'approve', name: 'Approve', description: 'Collect required approvals' },
  { id: 'apply', name: 'Apply', description: 'Execute changes in target environment' },
  { id: 'smoke', name: 'Smoke Tests', description: 'Run basic functionality tests' },
  { id: 'canary', name: 'Canary Checks', description: 'Monitor metrics during rollout' },
  { id: 'rollback', name: 'Rollback Hook', description: 'Automatic rollback on failure' },
  { id: 'record', name: 'Record', description: 'Generate audit records and evidence' }
];

export const guardrails = {
  prodRequirements: [
    'All checks must pass',
    'All required approvals received',
    'Maintenance window required for high-risk changes',
    'No tests, no apply - test suite must pass'
  ],
  blockedActions: [
    'Freeform script execution',
    'Non-catalog module references',
    'Direct infrastructure access',
    'Unapproved parameter values'
  ]
};